import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PartitionOutlinedSvg from "@ant-design/icons-svg/es/asn/PartitionOutlined";
import AntdIcon from "../components/AntdIcon";
var PartitionOutlined = function PartitionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PartitionOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PartitionOutlined.displayName = 'PartitionOutlined';
}
export default /*#__PURE__*/React.forwardRef(PartitionOutlined);